module.exports = __webpack_public_path__ + "static/img/COPERTINA-APP.b784a4f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/marketing/COPERTINA-APP.png
// module id = 1QJ6
// module chunks = 1